import { Alert } from 'antd';
import { useSimulation } from '../../context/SimulationContext';
import './TimeWarningBanner.scss';

function TimeWarningBanner() {
  const { timeWarning } = useSimulation();

  if (!timeWarning) return null;

  return (
    <Alert
      type="warning"
      banner
      closable
      message={`Time warning: ${timeWarning.turnsRemaining} turns remaining`}
      className="time-warning-banner"
    />
  );
}

export default TimeWarningBanner;
